import classcat from "classcat";
import React from "react";
import { useTranslation } from "react-i18next";

import { Button, ConfirmationModal } from "@touchtech/web-baselayer-ui";

import { TranslationContext } from "@is/constants";

import css from "./ResumeBasketModal.module.css";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onResume: () => void;
};

const ResumeBasketModal = ({ isOpen, onClose, onResume }: Props) => {
  const { t } = useTranslation(TranslationContext.Checkout);

  return (
    <ConfirmationModal isOpen={isOpen} onClose={onClose}>
      <div className={css.content}>
        <h1 className={classcat(["text-headline-5xl", css.title])}>
          {t("Resume Basket?")}
        </h1>
        <span className={classcat(["text-label-xl", css.subtitle])}>
          {t("Resuming this basket will reset your current search.")}
        </span>
        <Button
          className={classcat([css.button, css.resumeButton])}
          width="full"
          sizing="lg"
          onClick={onResume}
        >
          {t("Yes, resume basket")}
        </Button>
        <Button
          variant="tertiary"
          className={css.button}
          width="full"
          sizing="lg"
          onClick={onClose}
        >
          {t("Cancel")}
        </Button>
      </div>
    </ConfirmationModal>
  );
};

export default ResumeBasketModal;
